import { render, staticRenderFns } from "./MyImagesTab.vue?vue&type=template&id=1a55e4b8"
import script from "./MyImagesTab.vue?vue&type=script&lang=js"
export * from "./MyImagesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports